module.exports = __webpack_public_path__ + "static/bike_background-f4609f257037abdde7b94a23c8890163.png";